import { HIDE_DIALOG, HIDE_SHEET, OPEN_DIALOG, OPEN_SHEET } from './actionTypes';
import { isDialogOpen } from './functions';
import logger from './logger';
/**
 * Signals Dialog to close its dialog.
 *
 * @param {string|undefined} name - The name of the component for logging purposes.
 * @param {Object} [component] - The {@code Dialog} component to close/hide. If
 * {@code undefined}, closes/hides {@code Dialog} regardless of which
 * component it's rendering; otherwise, closes/hides {@code Dialog} only if
 * it's rendering the specified {@code component}.
 * @returns {{
 *     type: HIDE_DIALOG,
 *     component: (React.Component | undefined)
 * }}
 */
export function hideDialog(name, component) {
    logger.info(`Hide dialog: ${name}`);
    return {
        type: HIDE_DIALOG,
        component
    };
}
/**
 * Closes the active sheet.
 *
 * @returns {{
 *     type: HIDE_SHEET,
 * }}
 */
export function hideSheet() {
    return {
        type: HIDE_SHEET
    };
}
/**
 * Signals Dialog to open dialog.
 *
 * @param {string} name - The name of the component for logging purposes.
 * @param {Object} component - The component to display as dialog.
 * @param {Object} [componentProps] - The React {@code Component} props of the
 * specified {@code component}.
 * @returns {{
 *     type: OPEN_DIALOG,
 *     component: React.Component,
 *     componentProps: (Object | undefined)
 * }}
 */
export function openDialog(name, component, componentProps) {
    logger.info(`Open dialog: ${name}`);
    return {
        type: OPEN_DIALOG,
        component,
        componentProps
    };
}
/**
 * Opens the requested sheet.
 *
 * @param {Object} component - The component to display as a sheet.
 * @param {Object} [componentProps] - The React {@code Component} props of the
 * specified {@code component}.
 * @returns {{
 *     type: OPEN_SHEET,
 *     component: React.Component,
 *     componentProps: (Object | undefined)
 * }}
 */
export function openSheet(component, componentProps) {
    return {
        type: OPEN_SHEET,
        component,
        componentProps
    };
}
/**
 * Signals Dialog to open a dialog with the specified component if the component
 * is not already open. If it is open, then Dialog is signaled to close its
 * dialog.
 *
 * @param {string} name - The name of the component for logging purposes.
 * @param {Object} component - The component to display as dialog.
 * @param {Object} [componentProps] - The React {@code Component} props of the
 * specified {@code component}.
 * @returns {Function}
 */
export function toggleDialog(name, component, componentProps) {
    return (dispatch, getState) => {
        if (isDialogOpen(getState, component)) {
            dispatch(hideDialog(name, component));
        }
        else {
            dispatch(openDialog(name, component, componentProps));
        }
    };
}
